import * as S from './style.LotStatusNew';
import React, { startTransition, useEffect, useState, useTransition } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import SearchSelector from '../../components/form/SearchSelector';
import SearchSelectorNew from '../../components/form/SearchSelectorNew';
import TableForm from '../../components/form/TableForm';
import { RootState } from '../../modules';
import { showAlertModal } from '../../modules/action/alertAction';
import { ISearchBox, TableHeader, CSVHeader, IDropDown } from '../../types/type';
import { IDevice, ILotNumber, ILotStatusNew, ICustomerPn } from '../../types/userData';
import ApiUtil from '../../utils/ApiUtil';
import { getDate, getDateString, getMonthToMinute } from '../../utils/dateUtil';
import MySelect from '../../components/form/MySelector';
import CheckboxSelect from '../../components/form/CheckboxSelector';
import makeAnimated from "react-select/animated";
import { components } from "react-select";
import Loading from "../../components/common/Loading";
import { Console } from 'console';


const LotStatusTest = () =>{
    const langState = useSelector((state:RootState) => state.langReducer);

    const tableHeaders:TableHeader[] =[
        {text: langState.isKor? "고객명"          : "Customer",        width:"140px"},
        {text: langState.isKor? "고객PN"          : "Customer P/N",    width:"140px"},
        {text: langState.isKor? "제품"            : "SAWNICS P/N",     width:"140px"},
        {text: langState.isKor? "우선순위"        : "Priority",        width:"90px"},
        {text: langState.isKor? "로트"            : "LOT",             width:"100px"},
        {text: langState.isKor? "Process In"      : "Process In",      width:"100px"},
        {text: langState.isKor? "Total Step"      : "Total Step",      width:"80px"},
        {text: langState.isKor? "Current Step"    : "Current Step",    width:"100px"},
        {text: langState.isKor? "Process"         : "Process",         width:"100px"},
        {text: langState.isKor? "State"           : "State",           width:"70px"},    
        {text: langState.isKor? "In Qty"          : "In Qty",          width:"70px"},
        {text: langState.isKor? "Process Out Qty" : "Out Qty",         width:"70px"},
        {text: langState.isKor? "Issued Date"     : "Issued Date",     width:"90px"},
        {text: langState.isKor? "ETD"             : "ETD",             width:"90px"},
        {text: langState.isKor? "2nd ETD"         : "2nd ETD",         width:"90px"},
        {text: langState.isKor? "LIR_1"           : "LIR_1",           width:"300px"},
        {text: langState.isKor? "LIR_2"           : "LIR_2",           width:"300px"},
        {text: langState.isKor? "LIR_3"           : "LIR_3",           width:"300px"},
        {text: langState.isKor? "Ship Date"       : "Ship Date",       width:"90px"},
    ];

    const CSVHeaders:CSVHeader[] =[
        {label: langState.isKor? "고객명"          : "Customer",        key:"customer"      , value:"CUSTOMER"                                  },
        {label: langState.isKor? "고객PN"          : "Customer P/N",    key:"customerPn"    , value:"CUSTOMER_PN"                                },
        {label: langState.isKor? "제품"            : "SAWNICS P/N",     key:"device"        , value:"DEVICE"                                    },
        {label: langState.isKor? "우선순위"        : "Priority",        key:"priority"      , value:"PRIORITY"                                  },
        {label: langState.isKor? "로트"            : "LOT",             key:"lotNumber"     , value:"LOT_NUMBER"                                 },
        {label: langState.isKor? "Process In"      : "Process In",      key:"processIn"     , value:"PROCESS_IN"                                 },
        {label: langState.isKor? "Total Step"      : "Total Step",      key:"totalStep"     , value:"TOTAL_STEP"                                 },
        {label: langState.isKor? "Current Step"    : "Current Step",    key:"currentStep"   , value:"CURRENT_STEP"                               },
        {label: langState.isKor? "Process"         : "Process",         key:"process"       , value:"PROCESS"                                   },
        {label: langState.isKor? "State"           : "State",           key:"processState"  , value:"PROCESS_STATE"                              },
        {label: langState.isKor? "In Qty"          : "In Qty",          key:"inQty"         , value:"IN_QTY"                                     },
        {label: langState.isKor? "Process Out Qty" : "Process Out Qty", key:"processOutQty" , value:"PROCESS_OUT_QTY"                             },
        {label: langState.isKor? "Issued Date"     : "Issued Date",     key:"issuedDate"    , value:"ISSUED_DATE"                                },
        {label: langState.isKor? "ETD"             : "ETD",             key:"etd"           , value:"ETD"                                       },
        {label: langState.isKor? "2nd ETD"         : "2nd ETD",         key:"etd2nd"        , value:"ETD_2ND"                                    },
        {label: langState.isKor? "LIR_1"           : "LIR_1",           key:"lir1"          , value:"LIR_1"                                      },
        {label: langState.isKor? "LIR_2"           : "LIR_2",           key:"lir2"          , value:"LIR_2"                                      },
        {label: langState.isKor? "LIR_3"           : "LIR_3",           key:"lir3"          , value:"LIR_3"                                      },
        {label: langState.isKor? "Ship Date"       : "Ship Date",       key:"shipDate"      , value:"SHIP_DATE"                                  },
    ];
    
    // 제품, LOT 번호, 공정, LOT Status
    const [isLookDown,setIsLookDown] = useState(false);
    const [devices, setDevices] = useState<ISearchBox[]>([]);
    const [checkedDevices, setCheckedDevices] = useState<ISearchBox[]>([]);
    const [lotNumbers, setLotnumbers] = useState<ISearchBox[]>([]);
    const [checkedLotNumbers, setCheckedLotNumbers] = useState<ISearchBox[]>([]);
    // const [customerPns, setCustomerPns] = useState<IDropDown[]>([]);
    // const [checkedCustomerPns, setCheckedCustomerPns] = useState<IDropDown[]>([]);   
    const [customerPns, setCustomerPns] = useState<ISearchBox[]>([]);
    const [checkedCustomerPns, setCheckedCustomerPns] = useState<ISearchBox[]>([]);   

    const [tableBodies, setTableBodies] = useState<JSX.Element>((<tbody></tbody>));
    const [searchData, setSearchData] = useState<ILotStatusNew[]>([]);

    const [sortHeader, setSortHeader] = useState<IDropDown[]>([]);
    const [sortType, setSortType] = useState<IDropDown[]>([]);

    const [sortingCol, setSortingCol] = useState<number[]>([0,1,2,3,4,5]); // Sorting 할 해더 인덱스
    const [isPending, setisPending] = useState(false);

    var now = new Date();
    // jykim 2023.02.21 remark
    //const [startDate,setStartDate] = useState(new Date(now.setDate(now.getDate()-30)));
    const [startDate,setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const dispatch = useDispatch();

    const onSubmit =(event : React.FormEvent<HTMLFormElement>) =>{
        setisPending(true);
        event.preventDefault();
        async function callAPI(){           
            const params:object ={
                dates : {
                    startDate : getDateString(startDate),
                    endDate : getDateString(endDate)
                },
                devices : checkedDevices,
                lotNumbers : checkedLotNumbers,
                customerPn : checkedCustomerPns,
                sortColumns : sortHeader,
                sortTypes : sortType,
            }

            const res = await ApiUtil.post("/search/lot-status-new", params);    
            if(res.data.lotStatus.length == 0){
                if(langState.isKor)
                {
                    dispatch(showAlertModal("확인메세지","데이터","가 없습니다."));
                }else{
                    dispatch(showAlertModal("Information","Data"," does not exist."));
                }
                
            }
            console.log(res.data.lotStatus);
            setSearchData(res.data.lotStatus);
            setisPending(false);
        }
        callAPI();
    }

    useEffect(() =>{
        async function callAPI(){
            const res = await ApiUtil.get("/condition/deviceAndLotNumberAndOperation",  {params:{menuName:"lotStatus"}});

            // devices.splice(0,devices.length);
            // console.log("1");
            // res.data.devices.map((device:IDevice) =>{
            //   return devices.push({
            //         id : device.deviceId,
            //         text : device.description,
            //   })  
            // })
            // setDevices(devices);

            lotNumbers.splice(0,lotNumbers.length);
            res.data.lotNumbers.map((lotNumber:ILotNumber) =>{
                return lotNumbers.push({
                    id : lotNumber.id,
                    text : lotNumber.id,
                })
            })
            setLotnumbers(lotNumbers);

            customerPns.splice(0, customerPns.length);
            res.data.customerPn.map((customerPn:ICustomerPn) =>{
                return customerPns.push({
                    text : customerPn.label,
                    id : customerPn.value,
                })
            })
            //setCustomerPns(customerPns);
        }
        
        callAPI();
    },[devices, lotNumbers,customerPns ])

    useEffect (() =>{
        console.log(sortType);
        console.log(sortHeader);
    },[sortType, sortHeader])

    useEffect(() =>{    
        startTransition(()=>{
                setTableBodies((
                    <tbody key={"bodies"}>
                    {searchData.map((element,index) => (
                        <React.Fragment key={"body"+index}>
                            <tr>
                                <td><span>{element.customer}</span></td>
                                <td><span>{element.customerPn}</span></td>
                                <td><span>{element.device}</span></td>
                                <td><span>{element.priority}</span></td>
                                <td><span>{element.lotNumber}</span></td>
                                <td><span>{element.processIn}</span></td>
                                <td><span>{element.totalStep}</span></td>
                                <td><span>{element.currentStep}</span></td>
                                <td><span>{element.process}</span></td>
                                <td><span>{element.processState}</span></td>
                                <td><span>{element.inQty}</span></td>
                                <td><span>{element.processOutQty}</span></td>
                                <td><span>{element.issuedDate}</span></td>
                                <td><span>{element.etd}</span></td>
                                <td><span>{element.etd2nd}</span></td>
                                <td onClick={()=>dispatch(showAlertModal("LIR1","",element.lir1? element.lir1 : ""))} style={{cursor:'pointer'}}><span>{element.lir1}</span></td>
                                <td onClick={()=>dispatch(showAlertModal("LIR2","",element.lir2? element.lir2 : ""))} style={{cursor:'pointer'}}><span>{element.lir2}</span></td>
                                <td onClick={()=>dispatch(showAlertModal("LIR3","",element.lir3? element.lir3 : ""))} style={{cursor:'pointer'}}><span>{element.lir3}</span></td>
                                <td><span>{element.shipDate}</span></td>
                            </tr>
                        </React.Fragment>
                    ))}
                    </tbody>
                ));
            })
        },[searchData])

    
    return(
        <S.Container isLookDown={isLookDown} >
            {isPending && <Loading />}
            <form onSubmit={onSubmit}>
                <div className='condition_container'>
                    {/* <CheckboxSelect   
                        title={langState.isKor ? "고객 P/N" : "CUSTOMER P/N"}                     
                        options={customerPns}
                        //@ts-ignore
                        selected={checkedCustomerPns}
                        setSelected ={setCheckedCustomerPns} 
                    /> */}
                    <SearchSelectorNew
                        title={langState.isKor ? "고객 P/N" : "CUSTOMER P/N"}
                        list={customerPns}
                        selected={checkedCustomerPns}
                        selector={setCheckedCustomerPns}
                    />
                    {/* <SearchSelectorNew
                        title={langState.isKor ? "제품" : "Device"}
                        list={devices}
                        selected={checkedDevices}
                        selector={setCheckedDevices}
                    /> */}
                    <SearchSelectorNew
                        title={langState.isKor ? "LOT번호" : "LOT Numbers"}
                        list={lotNumbers}
                        selected={checkedLotNumbers}
                        selector={setCheckedLotNumbers}
                    />
                    
             </div>
                {/* <div className = "tableForm"> */}
                <TableForm
                    name ="LotStatus"
                    tableHeaders ={tableHeaders}
                    tableBodies = {tableBodies}
                    CSVHeaders = {CSVHeaders}
                    CSVData = {searchData}
                    isLookDown ={isLookDown}
                    setIsLookDown={setIsLookDown}
                    isDateRange={true}
                    isDatePicker={false}     // 날짜 입력부분 입력 : true , 제거 : false
                    startDate ={startDate}
                    endDate = {endDate}
                    setStartDate ={setStartDate}
                    setEndDate = {setEndDate}
                    isSortHeader = {false}
                    sortHeader={sortHeader}
                    setSortHeader={setSortHeader}
                    sortType={sortType}
                    setSortType={setSortType}
                    sortingCol={sortingCol}
                />
                {/* </div> */}
            </form>
        </S.Container>
    )
}

export default LotStatusTest